import React, { Component } from 'react'
import { Form, Input, Button } from 'antd'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'

const FormItem = Form.Item
const propTypes = {}
const AddItemArea = styled.div`
  padding: 15px;
  background-color: #f7f7f7;
`

class CreateAddressForm extends Component {
  onPhoneInputChange = e => {
    this.setState({
      phone_number: e.target
    })
  }

  onPhoneMobileInputChange = e => {
    this.setState({
      mobile_number: e.target
    })
  }

  handleCreate = () => {
    const form = this.props.form
    const { mobile_number, phone_number } = this.state
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.mobile_number = mobile_number ? mobile_number : null
      values.phone_number = phone_number ? phone_number : null

      this.props.addContact(values)
    })
  }
  handleUpdate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      this.props.saveContact(values)
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const { contentData } = this.props
    return (
      <div className="addressForm">
        <AddItemArea>
          <Form layout="vertical">
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Role">
                  {getFieldDecorator('role', {
                    initialValue: contentData ? contentData.role : ''
                  })(<Input />)}
                </FormItem>
              </div>
              <div className="col-md-6">
                <FormItem label="Email">
                  {getFieldDecorator('email', {
                    initialValue: contentData ? contentData.email : ''
                  })(<Input placeholder="Type in email address..." />)}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <FormItem label="First Name">
                  {getFieldDecorator('first_name', {
                    rules: [
                      {
                        required: true,
                        message: 'First Name cannot be blank.'
                      }
                    ],
                    initialValue: contentData ? contentData.first_name : ''
                  })(<Input placeholder="Enter first name..." />)}
                </FormItem>
              </div>
              <div className="col-md-6">
                <FormItem label="Last Name">
                  {getFieldDecorator('last_name', {
                    initialValue: contentData ? contentData.last_name : ''
                  })(<Input placeholder="Enter Last Name..." />)}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Phone Number">
                  {getFieldDecorator('phone_number', {
                    initialValue: ''
                  })(
                    <NumberFormat
                      format="(###) ###-#### ext:####"
                      mask="_"
                      onValueChange={values => {
                        const e = { target: values.value }
                        this.onPhoneInputChange(e)
                      }}
                      className="ant-input"
                    />
                  )}
                </FormItem>
              </div>
              <div className="col-md-6">
                <FormItem label="Mobile Number">
                  {getFieldDecorator('mobile_number', {
                    initialValue: ''
                  })(
                    <NumberFormat
                      format="(###) ###-####"
                      mask="_"
                      onValueChange={values => {
                        const e = { target: values.value }
                        this.onPhoneMobileInputChange(e)
                      }}
                      className="ant-input"
                    />
                  )}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {!contentData && <Button onClick={() => this.handleCreate()}>Add contact</Button>}
                {contentData && <Button onClick={() => this.handleUpdate()}>Save contact</Button>}
              </div>
            </div>
          </Form>
        </AddItemArea>
      </div>
    )
  }
}

CreateAddressForm.propTypes = propTypes
export default Form.create()(CreateAddressForm)



// WEBPACK FOOTER //
// ./src/components/CreateCompanyContactForm.js